import React from "react";

const photoPath = "https://portfolio-images-juhani.s3.eu-north-1.amazonaws.com/";

const education = [
  {
    logo: photoPath + "vyy_logo.png",
    alt: "University of Vaasa",
    title: "M.Sc. in Economics",
    org: "University of Vaasa",
    year: "2007 — 2011",
    text: "Majored in business law, minored in accounting.",
  },
  {
    logo: photoPath + "codecademy_logo.png",
    alt: "Codecademy",
    title: "Full-Stack Developer",
    org: "Codecademy",
    year: "Ongoing",
    text: "Currently working through the full-stack developer path.",
  },
  {
    logo: photoPath + "finva_logo.png",
    alt: "FINVA",
    title: "Insurance Degree (VTS)",
    org: "FINVA",
    year: "2013",
    text: "Professional degree covering all major topics in the insurance industry.",
  },
];

export default function Education() {
  return (
    <div>
      <p
        className="reveal"
        style={{
          fontFamily: "var(--mono)",
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.16em",
          color: "var(--cyan)",
          marginBottom: "28px",
        }}
      >
        ▮ FLIGHT RECORD // EDUCATION
      </p>

      <div style={{ borderTop: "1px solid var(--line)" }}>
        {education.map((el) => (
          <div
            key={el.title}
            className="reveal edu-row"
            data-stagger="80"
            style={{
              display: "grid",
              gridTemplateColumns: "64px minmax(0,1.4fr) minmax(0,1fr) auto",
              gap: "clamp(16px, 4vw, 40px)",
              alignItems: "center",
              padding: "24px 0",
              borderBottom: "1px solid var(--line)",
            }}
          >
            <div
              style={{
                width: "64px",
                height: "64px",
                background: "rgba(230,244,255,0.92)",
                border: "1px solid var(--line-strong)",
                display: "grid",
                placeItems: "center",
                padding: "10px",
              }}
            >
              <img
                src={el.logo}
                alt={el.alt}
                style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
              />
            </div>

            <div>
              <h4
                style={{
                  fontFamily: "var(--display)",
                  fontSize: "clamp(1.15rem, 2.5vw, 1.6rem)",
                  fontWeight: 600,
                  lineHeight: 1.1,
                  textTransform: "uppercase",
                  color: "var(--text)",
                }}
              >
                {el.title}
              </h4>
              <p
                style={{
                  fontFamily: "var(--mono)",
                  fontSize: "0.7rem",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  color: "var(--cyan)",
                  marginTop: "6px",
                }}
              >
                {el.org}
              </p>
            </div>

            <p style={{ color: "var(--text-soft)", fontSize: "0.94rem", lineHeight: 1.6 }}>
              {el.text}
            </p>

            <span
              style={{
                fontFamily: "var(--mono)",
                fontSize: "0.78rem",
                color: "var(--text-faint)",
                whiteSpace: "nowrap",
                textAlign: "right",
              }}
            >
              {el.year}
            </span>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 720px) {
          .edu-row { grid-template-columns: 48px 1fr !important; }
          .edu-row > p, .edu-row > span {
            grid-column: 2 !important;
            text-align: left !important;
          }
        }
      `}</style>
    </div>
  );
}
